// extracted by mini-css-extract-plugin
export default {"mainContainer":"FreeDelivery_mainContainer__-GuKO","squareFilterBarWrapper":"FreeDelivery_squareFilterBarWrapper__0EcMn"};